import AuditHistoryTable from './AuditHistoryTable';
export default AuditHistoryTable;
